





















































































  import {Component, Vue} from 'vue-property-decorator';

  import LoginLayout from '@/layouts/LoginLayout.vue';
  import {authenticate} from '@/repositories/api/SecurityApiRepository';
  import SecurityModule from '@/store/modules/SecurityModule';
  import User from '@/models/User';
  import Alert from '@/models/Alert';
  import {AlertTypes} from '@/models/AlertTypes';

  @Component({
    components: {
      LoginLayout,
    },
  })
  export default class AuthenticationView extends Vue {
    valid = false;
    alert = new Alert();
    key = '';
    keyLength = 30;
    loading = false;

    emailRules = [
      (value: string) => !!value || 'Un e-mail est requis',
      (value: string) => /.+@.+/.test(value) || 'L\'email doit être valide',
    ];

    keyRules = [
      (value: string) => !!value || 'Clé requise',
      (value: string) => value.length === this.keyLength || 'La clé doit contenir 30 caractères',
    ];


    async login() {
      this.loading = true;
      let response: {token: string, user: User} | null = null;
      let success = true;

      try {
        response = await authenticate(this.key);
      } catch (e) {
        success = false;

        this.alert = new Alert('Clé d\'authentification incorrect', AlertTypes.Error, true);
      }

      this.loading = false;

      if(success && response){
        SecurityModule.setToken(response.token);
        SecurityModule.setUser(response.user);
        await this.$router.push({name: 'home'})
      }

    }

    mounted() {
      if (this.$route.query.token) {
        this.key = this.$route.query.token + "";
        this.login();
      }
    }
}
